
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"c-video-control\" style=\"bottom: -200px\">\n    <div class=\"c-video-control__button c-video-control__button--play\"></div>\n    ")
    ; if(isLive) {
    ; __append("\n    <div class=\"c-video-control__desc\">\n        ")
    ;  if(isLive === '0'){ 
    ; __append(" 预告 ")
    ;  }else if(isLive === '1'){ 
    ; __append(" 正在直播\n        ")
    ;  }else{ 
    ; __append(" 回顾 ")
    ;  } 
    ; __append("\n    </div>\n    ")
    ;  } 
    ; __append("\n    <div class=\"c-video-control__timebar\">\n        <div>\n            <span></span> <em><i></i></em>\n        </div>\n    </div>\n    <div class=\"c-video-control__time\">--</div>\n    <div class=\"c-video-control__zoom c-video-control__zoom--zoomin\"></div>\n</div>\n")
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/modules/f.compenont.video.mobile/app/modules/recodeControl/main.ejs
// module id = 496
// module chunks = 0